module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/tick-6d986439262264b8687ec004b7b8f196.png";